export default "__VITE_ASSET__DJkEpq6V__"